(function () {
  function initMobileDrawer() {
    document.querySelectorAll('[data-tp-mobile-back]').forEach(function (button) {
      button.addEventListener('click', function () {
        var topDetails = button.closest('.tp-mobile-top');
        if (topDetails) {
          topDetails.removeAttribute('open');
        }
      });
    });

    document.querySelectorAll('.tp-mobile-top').forEach(function (topDetails) {
      topDetails.addEventListener('toggle', function () {
        if (!topDetails.open) {
          // Reset to the fully-condensed state so every section is visible on re-open.
          topDetails.querySelectorAll('.tp-mobile-category[open]').forEach(function (category) {
            category.removeAttribute('open');
          });
        }
      });
    });

    // Single-open accordion: opening one category collapses the others in the same group.
    document.querySelectorAll('.tp-mobile-accordion').forEach(function (accordion) {
      var categories = accordion.querySelectorAll('.tp-mobile-category');
      categories.forEach(function (category) {
        category.addEventListener('toggle', function () {
          if (!category.open) {
            return;
          }
          categories.forEach(function (other) {
            if (other !== category) {
              other.removeAttribute('open');
            }
          });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initMobileDrawer);
})();